<wiz-hgroup width="100%" height="100%" verticalAlign='center' horizontalAlign='center' style="padding: 5px;">
  <wiz-image #imgBU [sourceObservable]="data[0].iconOrDie" width="40px" height="40px"></wiz-image>
  <wiz-label #lbName [wizLabel]="data[0].trsWarnDetail"></wiz-label>
</wiz-hgroup>
